'use client';

import { createContext, ReactNode, useContext } from 'react';
import { EntitlementMap } from './types';

const Ctx = createContext<EntitlementMap | null>(null);

export function EntitlementsProvider({
  value,
  children
}: {
  value: EntitlementMap;
  children: ReactNode;
}) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useEntitlements(): EntitlementMap {
  const v = useContext(Ctx);
  if (!v)
    throw new Error('useEntitlements called outside EntitlementsProvider');
  return v;
}
